import { getLocale } from "apis/backend";
import { doCall } from "common/genericSaga";
import { call, put, takeLatest } from "redux-saga/effects";
import { LOCALE_REQUESTED, LOCALE_REQUEST_FAILED, receiveLocale } from "./localeActions";

export function* doRequestLocale(action) {
  const localeMessages = yield call(getLocale, action.localeId);
  yield put(receiveLocale(action.localeId, localeMessages));
}

export function* watchLocale() {
  yield takeLatest(LOCALE_REQUESTED, doCall(doRequestLocale, LOCALE_REQUEST_FAILED));
}
